import styled from "styled-components"
import {useDeleteCommentMutation, useFindAllNoOperCommentByEui} from "hooks/queries/non-oper-comment.query"
import {NoneOperationComment} from "dto/realdevice/none-operation-comment"
import dayjs from "dayjs"
import {Pagination} from "common/Pagination"
import {useState} from "react"

const size = 10
export const NoneOperationCommentList = ({eui, selectItem}: { eui: string, selectItem: (id: number) => void }) => {
    const [page, setPage] = useState(0)
    const {data: response} = useFindAllNoOperCommentByEui(eui, page, size)
    const deleteCommentMutation = useDeleteCommentMutation()
    const deleteDevice = (id: number) => {
        if (!window.confirm("삭제 하시겠습니까?")) return
        deleteCommentMutation.mutate(id)
    }

    const content = response?.content || []
    const totalElements = response?.totalElements || 0
    const list = content as NoneOperationComment[] || [] as NoneOperationComment[]
    return (
        <>
            <div className="main-box">
                <div className="grid-table2 grid-pop-table">
                    <ListHeader/>
                    {list.map((item, index) => {
                        const {fromDate, endDate, id, comment} = item
                        const from = dayjs(fromDate).format("YYYY-MM-DD")
                        const to = dayjs(endDate).format("YYYY-MM-DD")
                        const indexNo = (page * size) + index + 1
                        return (
                            <ListItem key={id} title={comment}>
                                <ListItemColumn>{indexNo}</ListItemColumn>
                                <ListItemColumn>{from}</ListItemColumn>
                                <ListItemColumn>{to}</ListItemColumn>
                                <ListItemColumn>
                                    <button
                                        className="button is-primary is-inverted"
                                        onClick={() => {
                                            id &&
                                            selectItem(id)
                                        }}>보기
                                    </button>
                                    <button
                                        className="button is-danger is-inverted" onClick={() => {
                                        if (!id) return
                                        deleteDevice(id)
                                    }}>삭제
                                    </button>
                                </ListItemColumn>
                            </ListItem>
                        )
                    })}

                </div>
                <Pagination changePage={(page: number) => {
                    setPage(page - 1)
                }} total={totalElements} size={size} page={page + 1}/>
            </div>
        </>
    )
}

const ListHeader = () => {
    return (
        <ListHeaderBox>
            <div className="item ">번호</div>
            <div className="item">미운행 시작일</div>
            <div className="item ">미운행 종료일</div>
            <div className="item ">관리</div>
        </ListHeaderBox>
    )
}

const ListItem = styled.div`
  width: 100%;
  display: grid;
  border: 0;
  padding: 2px 2px 2px 2px;
  grid-template-columns: auto 30% 30% 25%;
`

const ListItemColumn = styled.div`
  text-align: center;
  //vertical-align: middle;
  line-height: 35px;
  padding: 2px 0;
  font-size: 1rem;
  font-weight: 400;
`

const ListHeaderBox = styled.header`
  width: 100%;
  display: grid;
  color: #353536;
  border: 0;
  background: #e9f0f5;
  grid-template-columns: auto 30% 30% 25%;
`